module.exports = new __parcel__URL__("Archerskill_44.d0820720.png").toString();